class Modal {
    constructor() {
        this.html = document.documentElement;
        this.body = document.body;
        this.modal = ".js-modal";
        this.trigger = ".js-modal-trigger";
        this.activeClass = "modal__open";
        this.videoClass = "js-modal-video";
    }

    bindTriggers() {
        const buttons = Array.from(document.querySelectorAll(this.trigger));
        buttons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                const action = e.target.getAttribute("data-action");
                const id = e.target.getAttribute("data-id");
                this.toggleModal(id, action);
            });
        });
    }

    bindKeyboard() {
        document.addEventListener("keydown", e => {
            if (e.keyCode === 27) {
                const activeModals = Array.from(
                    document.getElementsByClassName(this.activeClass)
                );
                activeModals.forEach(modal => {
                    const id = modal.id;
                    this.toggleModal(id, "");
                });
            }
        });
    }

    toggleVideo(modal) {
        if (modal.classList.contains(this.videoClass)) {
            const video = modal.querySelector(".js-video");
            if (modal.classList.contains(this.activeClass)) {
                let videoSrc = video.getAttribute("data-src");
                video.src = videoSrc;
            } else {
                video.src = "";
            }
        }
    }

    toggleModal(id, action) {
        const modal = document.getElementById(id);
        if (action == "open") {
            this.html.classList.add("locked");
            modal.classList.add(this.activeClass);
            if (modal.classList.contains(this.videoClass)) {
                this.toggleVideo(modal);
            }
        } else {
            this.html.classList.remove("locked");
            modal.classList.remove(this.activeClass);
            if (modal.classList.contains(this.videoClass)) {
                this.toggleVideo(modal);
            }
        }
    }

    appendModals() {
        const modals = document.querySelectorAll(this.modal);
        for (var i = 0; i < modals.length; i++) {
            document.body.appendChild(modals[i]);
        }
    }

    init() {
        this.bindTriggers();
        this.bindKeyboard();
        this.appendModals();
    }
}

export default Modal;



// WEBPACK FOOTER //
// ../project/craft/src/components/modal/modal.js